(() => {
  const SELECTOR = '[data-home-carousel]';

  function initCarousel(root) {
    if (!root || root.dataset.carouselReady === 'true') return;

    const slides = Array.from(root.querySelectorAll('[data-carousel-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-carousel-dot]'));
    const previous = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');

    if (slides.length < 2) return;

    root.dataset.carouselReady = 'true';

    let activeIndex = 0;
    let timer = null;
    const interval = Math.max(3000, Number.parseInt(root.dataset.interval || '5000', 10));
    const autoplay = root.dataset.autoplay === 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const render = (index) => {
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    };

    const stop = () => {
      if (timer !== null) {
        window.clearTimeout(timer);
        timer = null;
      }
    };

    const schedule = () => {
      stop();
      if (!autoplay || reducedMotion || document.hidden) return;
      timer = window.setTimeout(() => {
        render(activeIndex + 1);
        schedule();
      }, interval);
    };

    const goTo = (index) => {
      render(index);
      schedule();
    };

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));

    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number.parseInt(dot.dataset.carouselDot, 10)));
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', schedule);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) schedule();
    });

    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
      if (event.key === 'ArrowRight') goTo(activeIndex + 1);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else schedule();
    });

    render(0);
    schedule();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
